import { MatDateFormats } from '@angular/material/core';

/** Shown under the homepage date field. Matches {@link AU_DATE_FORMATS} parse/display. */
export const AU_DATE_INPUT_HINT = 'DD/MM/YYYY';

/**
 * Day-first patterns. date-fns token `P` follows whichever locale is active;
 * these tokens keep typed input and the field display on dd/MM/yyyy.
 */
export const AU_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: ['dd/MM/yyyy', 'd/M/yyyy'],
    timeInput: 'p',
  },
  display: {
    dateInput: 'dd/MM/yyyy',
    timeInput: 'p',
    monthYearLabel: 'LLL uuuu',
    dateA11yLabel: 'dd MMMM yyyy',
    monthYearA11yLabel: 'LLLL uuuu',
    timeOptionLabel: 'p',
  },
};
